module.exports = __webpack_public_path__ + "static/media/monitoring.4891d7ab.png";